import React from 'react';
import { Show } from '@refinedev/antd';
import { useShow } from '@refinedev/core';
import { Tag, theme } from 'antd';
import { Field } from '../../components/Field';

interface LanguageDto {
  id: string;
  code: string;
  label: string;
  isActive: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

const tagStyle = (color: string) => ({
  borderColor: color,
  color,
  background: `${color}15`,
  borderRadius: 9999,
  padding: '2px 12px',
  fontWeight: 500,
});

export const LanguageShow: React.FC = () => {
  const { token } = theme.useToken();
  const { queryResult } = useShow<LanguageDto>({ resource: 'languages' });
  const item = queryResult?.data?.data;

  if (!item) {
    return <div style={{ color: token.colorTextSecondary }}>Loading...</div>;
  }

  return (
    <Show resource="languages">
      <div style={{ padding: '8px 0' }}>
        <Field label="Code">{item.code}</Field>
        <Field label="Label">{item.label}</Field>
        <Field label="Active">
          <Tag style={tagStyle(item.isActive ? '#3ecf8e' : '#898989')}>
            {item.isActive ? 'Active' : 'Inactive'}
          </Tag>
        </Field>
        <Field label="Sort Order">{item.sortOrder}</Field>
        <Field label="Created At">{new Date(item.createdAt).toLocaleString()}</Field>
        <Field label="Updated At">{new Date(item.updatedAt).toLocaleString()}</Field>
      </div>
    </Show>
  );
};
